import React from "react";
import { Link } from "react-scroll";
import { FaAndroid, FaWindows, FaAppStoreIos, FaHtml5 } from "react-icons/fa";
import { TypeAnimation } from "react-type-animation";
import { motion } from "framer-motion";
import { fadeIn } from "../variants";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards, Autoplay } from "swiper";

const Banner = () => {
  return (
    <section id="home" className="min-h-[85vh] lg:min-h-[78vh] flex items-center">
      <div className="container mx-auto">
        <div className="flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12">
          <div className="flex-1 text-center lg:text-left">
            <motion.h1
              variants={fadeIn("up", 0.2)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.7 }}
              className="text-[50px] text-secondBlue font-primary font-bold leading-[0.8] lg:text-[90px]"
            >
              EML <span className="text-secondBlue">S.A.S</span>
            </motion.h1>
            <motion.div
              variants={fadeIn("up", 0.2)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.7 }}
              className="mb-6 text-[24px] lg:text-[30px] font-primary font-semibold uppercase leading-[1]"
            >
              <span className="mr-2 text-secondBlue">Somos</span>
              <TypeAnimation
                sequence={["Innovadores", 2000, "Modernos", 2000, "Creativos", 2000, "Tecnológicos", 2000, "Gamers", 2000]}
                speed={50}
                className="text-mainYellow"
                wrapper="span"
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              variants={fadeIn("up", 0.4)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.7 }}
              className="text-mainBlue mb-8 max-w-lg mx-auto lg:mx-0"
            >
              En este portafolio encontrarás ejemplos de proyectos desarrollados por el grandioso equipo de <strong>EML</strong>. Siéntete libre de explorar el contenido ¡y disfruta tu estadía en la página!
            </motion.p>
            <motion.div
              variants={fadeIn("up", 0.5)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.7 }}
              className="flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0"
            >
              <Link to="work" smooth={true} spy={true} className="cursor-pointer text-gradient btn-link">
                <button className="btn btn-lg">Nuestro portafolio</button>
              </Link>
            </motion.div>
            <motion.div
              variants={fadeIn("up", 0.6)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.7 }}
              className="flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0"
            >
              <button type="button" className="text-mainBlue cursor-pointer" aria-label="HTML5">
                <FaHtml5 />
              </button>
              <button type="button" className="text-mainBlue cursor-pointer" aria-label="Windows">
                <FaWindows />
              </button>
              <button type="button" className="text-mainBlue cursor-pointer" aria-label="Android">
                <FaAndroid />
              </button>
              <button type="button" className="text-mainBlue cursor-pointer" aria-label="App Store iOS">
                <FaAppStoreIos />
              </button>
            </motion.div>
          </div>
          <motion.div
            variants={fadeIn("left", 0.4)}
            initial="hidden"
            whileInView="show"
            className="hidden lg:flex flex-1 max-w-[320px] lg:max-w-[320px] relative bg-about bg-contain bg-no-repeat bg-bottom"
          >
            <Swiper effect="cards" modules={[EffectCards, Autoplay]} autoplay={{ delay: 3000, disableOnInteraction: false }} className="w-[320px] h-[520px] wor1">
              <SwiperSlide className="items-center justify-center" style={{ display: "flex", height: 532, border: "1px solid rgba(255, 255, 255, 0.1)", background: "transparent", boxShadow: "none", borderRadius: "41px" }}>
                <a href="https://eml.com.co/reto_mucosolvan/CostaRica/index01-CR.html" target="_blank" rel="noreferrer">
                  <img src="/image3.png" style={{ width: 267, borderRadius: 41, border: "1px solid rgba(255, 255, 255, 0.1)" }} alt="Proyecto EML" />
                </a>
              </SwiperSlide>
              <SwiperSlide className="items-center justify-center" style={{ display: "flex", height: 532, border: "1px solid rgba(255, 255, 255, 0.1)", background: "transparent", boxShadow: "none", borderRadius: "41px" }}>
                <a href="https://www.grupoamarey.com/" target="_blank" rel="noreferrer">
                  <img src="/image.png" className="w-full h-full" style={{ width: 267, borderRadius: 41, border: "1px solid rgba(255, 255, 255, 0.1)" }} alt="Rompecabezas" />
                </a>
              </SwiperSlide>
              <SwiperSlide className="items-center justify-center" style={{ display: "flex", height: 532, border: "1px solid rgba(255, 255, 255, 0.1)", background: "transparent", boxShadow: "none", borderRadius: "41px" }}>
                <a href="https://propuesta-de-valor-bristol.vercel.app/AV%20Propuesta%20de%20Valor%20Bristol.html" target="_blank" rel="noreferrer">
                  <img src="/imagen10.png" style={{ width: 267, borderRadius: 41, border: "1px solid rgba(255, 255, 255, 0.1)" }} alt="Bubble Shooter" />
                </a>
              </SwiperSlide>
              <SwiperSlide className="items-center justify-center" style={{ display: "flex", height: 532, border: "1px solid rgba(255, 255, 255, 0.1)", background: "transparent", boxShadow: "none", borderRadius: "41px" }}>
                <a href="https://sospechar-eml.eml.com.co/" target="_blank" rel="noreferrer">
                  <img src="/image1.png" style={{ width: 267, borderRadius: 41, border: "1px solid rgba(255, 255, 255, 0.1)" }} alt="Sospechar" />
                </a>
              </SwiperSlide>
              <SwiperSlide className="items-center justify-center" style={{ display: "flex", height: 532, border: "1px solid rgba(255, 255, 255, 0.1)", background: "transparent", boxShadow: "none", borderRadius: "41px" }}>
                <a href="https://pintacademy.com/es" target="_blank" rel="noreferrer">
                  <img src="/image2.png" style={{ width: 267, borderRadius: 41, border: "1px solid rgba(255, 255, 255, 0.1)" }} alt="Candy" />
                </a>
              </SwiperSlide>
            </Swiper>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
